module.exports = __webpack_public_path__ + "img/jiu1.95fc9c20.png";